module.exports = __webpack_public_path__ + "img/stray-logo.228d3219.svg";